'use client';

import React, { FC, useState } from 'react';
import { usePathname } from 'next/navigation';
import styled from 'styled-components';

import Button from '@/components/Button/Button';
import Link from '@/components/Link/Link';
import { StarIcon } from '@/public/icons';
import { devices } from '@/styles/breakpoints';
interface IProps {
  items: {
    title: string;
    path: string;
  }[];
}

const ListItem = ({
  item,
}: {
  item: { title: string; path: string };
}): JSX.Element => {
  const currentPath = usePathname();

  return (
    <ItemWrapper>
      {currentPath === item.path ? (
        <ItemWrapperInner>
          <StarIcon />
          <ItemTitle>{item.title}</ItemTitle>
        </ItemWrapperInner>
      ) : (
        <Link href={item.path}>
          <ItemWrapperInner>
            <StarIcon />
            <ItemTitle>{item.title}</ItemTitle>
          </ItemWrapperInner>
        </Link>
      )}
    </ItemWrapper>
  );
};

export const ListItems: FC<IProps> = ({ items }) => {
  const [open, setOpen] = useState(false);
  const toggle = () => {
    setOpen((prev) => !prev);
  };
  return (
    <Wrapper>
      <ItemsWrapper open={open}>
        {items.map((item, idx) => (
          <ListItem key={idx} item={item} />
        ))}
      </ItemsWrapper>
      <ButtonWrapper>
        <Button className="bluer" onClick={toggle} fullWidth>
          {open ? 'Hide All' : 'Show All'}
        </Button>
      </ButtonWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 20px 0;
  @media only screen and ${devices.desktop} {
    padding: 0 0 40px;
  }
`;

const ItemsWrapper = styled.ul<{ open: boolean }>`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 20px;
  padding: 0;
  padding-top: 10px;
  list-style: none;
  height: ${(props) => (props.open ? '100%' : '344px')};
  overflow: hidden;
  @media only screen and ${devices.desktop} {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`;

const ButtonWrapper = styled.div`
  padding-top: 24px;
  @media only screen and ${devices.desktop} {
    display: none;
  }
`;

const ItemWrapper = styled.li`
  padding: 0;
  text-decoration: none;
  list-style: none;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  & .navigation-link {
    text-decoration: none;
    color: rgba(38, 38, 38, 1);
  }
`;

const ItemWrapperInner = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ItemTitle = styled.p`
  font-family: var(--font--roboto);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
`;
